import React from 'react';
import '../../styles/footer.css';

const Footer = () => {
  return (
    <footer>
      <p>© 2025 Franco.dev</p>
    </footer>
  );
};

export default Footer;
